import React from 'react';

import { FooterRowSkeleton } from '@sharedComponents/Skeletons';
import { StyledCheckoutWrapper } from '@styles/generalStyles';
import { ReactFCV } from '@types';

import { CartPageContentSkeleton } from './components';
import { StyledTitle, StyledTitleWrapper } from './styled';

export const CartPageSkeleton: ReactFCV = () => (
  <StyledCheckoutWrapper data-testid="styled-checkout-wrapper">
    <StyledTitleWrapper data-testid="styled-title-wrapper">
      <StyledTitle data-testid="styled-title" width={12.375} />
    </StyledTitleWrapper>
    <CartPageContentSkeleton />
    <FooterRowSkeleton data-testid="footer-row-skeleton" />
  </StyledCheckoutWrapper>
);
